import { createRoutine } from 'redux-saga-routines'
import { call, fork, put, takeLatest } from '@redux-saga/core/effects'
import { toast } from 'react-toastify'
import { getApiErrors } from 'utils/errors'
import * as dictionariesService from 'services/dictionariesService'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'

export const getFileCategoriesRoutine = createRoutine('GET_FILE_CATEGORIES')
export const getFoldersRoutine = createRoutine('GET_FOLDERS')

function* getFileCategories() {
  yield put(getFileCategoriesRoutine.request())
  try {
    const { data } = yield call(dictionariesService.getFileCategories)
    yield put(getFileCategoriesRoutine.success(data.data))
  } catch (error) {
    !checkIsOnline() || (getApiErrors(error)?.trim() && toast.error(getApiErrors(error)))
    yield put(getFileCategoriesRoutine.failure(error))
  }
}

function* getFolders() {
  yield put(getFoldersRoutine.request())
  try {
    const { data } = yield call(dictionariesService.getFolders)
    yield put(getFoldersRoutine.success(data.data))
  } catch (error) {
    !checkIsOnline() || (getApiErrors(error)?.trim() && toast.error(getApiErrors(error)))
    yield put(getFoldersRoutine.failure(error))
  }
}

export function* getFileCategoriesWatcher() {
  yield takeLatest(getFileCategoriesRoutine.TRIGGER, getFileCategories)
}

export function* getFoldersWatcher() {
  yield takeLatest(getFoldersRoutine.TRIGGER, getFolders)
}

export const dictionariesSagas = [
  fork(getFileCategoriesWatcher),
  fork(getFoldersWatcher)
]
